import {
  AdminBulkUploadApiFactory,
  V1BulkGatewaysTransactionRow,
  V1BulkGatewaysTransactionResponse,
  V1BulkSensorsTransactionResponse,
  V1BulkSensorsTransactionRow,
  V1BulkTabletsTransactionResponse,
  V1BulkTabletsTransactionRow,
} from '@vacancorp/enterprise-for-client.vacanservice.com'
import { BulkGatewaysTransactionRow, BulkSensorsTransactionRow, BulkTabletsTransactionRow } from '@/models'
import { api, ApiResponse, createApiError, BulkUploadResponse } from './base'

function createBulkUploadGatewaysRes(res: V1BulkGatewaysTransactionResponse): BulkUploadResponse<BulkGatewaysTransactionRow> {
  const transactionId: string | undefined = res.transactionId

  let rows: BulkGatewaysTransactionRow[]
  if (res.data == undefined) {
    rows = []
  } else {
    rows = res.data.map((r: V1BulkGatewaysTransactionRow) => {
      return new BulkGatewaysTransactionRow(r)
    })
  }

  return {
    transactionId: transactionId || "",
    rows,
  }
}

function createBulkUploadSensorsRes(res: V1BulkSensorsTransactionResponse): BulkUploadResponse<BulkSensorsTransactionRow> {
  const transactionId: string | undefined = res.transactionId

  let rows: BulkSensorsTransactionRow[]
  if (res.data == undefined) {
    rows = []
  } else {
    rows = res.data.map((r: V1BulkSensorsTransactionRow) => {
      return new BulkSensorsTransactionRow(r)
    })
  }

  return {
    transactionId: transactionId || "",
    rows,
  }
}

function createBulkUploadTabletsRes(res: V1BulkTabletsTransactionResponse): BulkUploadResponse<BulkTabletsTransactionRow> {
  const transactionId: string | undefined = res.transactionId

  let rows: BulkTabletsTransactionRow[]
  if (res.data == undefined) {
    rows = []
  } else {
    rows = res.data.map((r: V1BulkTabletsTransactionRow) => {
      return new BulkTabletsTransactionRow(r)
    })
  }

  return {
    transactionId: transactionId || "",
    rows,
  }
}

export const NewAdminBulkUploadApi = () => {
  const webAdapter = AdminBulkUploadApiFactory(undefined, api.defaults.baseURL, api)

  return {
    bulkUploadGateways: async (companyId: string, body: File): Promise<ApiResponse<BulkUploadResponse<BulkGatewaysTransactionRow> | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.bulkUploadGateways(companyId, body)
        data = createBulkUploadGatewaysRes(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    commitGateways: async (companyId: string, transactionId: string): Promise<ApiResponse<string | undefined>> => {
      let data, err

      try {
        const params = {transactionId: transactionId} // eslint-disable-line @typescript-eslint/camelcase
        const res = await webAdapter.bulkCommitGateways(companyId, params)
        data = res.data.transactionId
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    bulkUploadSensors: async (companyId: string, body: File): Promise<ApiResponse<BulkUploadResponse<BulkSensorsTransactionRow> | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.bulkUploadSensors(companyId, body)
        data = createBulkUploadSensorsRes(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    commitSensors: async (companyId: string, transactionId: string): Promise<ApiResponse<string | undefined>> => {
      let data, err

      try {
        const params = {transactionId: transactionId} // eslint-disable-line @typescript-eslint/camelcase

        const res = await webAdapter.bulkCommitSensors(companyId, params)
        data = res.data.transactionId
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    bulkUploadTablets: async (companyId: string, body: File): Promise<ApiResponse<BulkUploadResponse<BulkTabletsTransactionRow> | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.bulkUploadTablets(companyId, body)
        data = createBulkUploadTabletsRes(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    commitTablets: async (companyId: string, transactionId: string): Promise<ApiResponse<string | undefined>> => {
      let data, err

      try {
        const params = {transactionId: transactionId} // eslint-disable-line @typescript-eslint/camelcase

        const res = await webAdapter.bulkCommitTablets(companyId, params)
        data = res.data.transactionId
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    }
  }
}